import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance90 = () => {
  let winners = ["220"];
  return <IndividualTable matchType={"3"} gender="M" event="90" subTitle="TarscaShild" data={sampleData} topRankCount="1" winners={winners} />;
};
export default Distance90;
